import { render, staticRenderFns } from "./IFire.vue?vue&type=template&id=bfd0628e&"
import script from "./IFire.vue?vue&type=script&lang=ts&"
export * from "./IFire.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports